require('./brokerTransferValuesTable.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
// @ components
const BrokerTransferValuesTableRow = require('components/broker/brokerTransferValuesSteps/brokerTransferValuesStep2/brokerTransferValuesTableRow/brokerTransferValuesTableRow');
// @ actions
const { toggleCheckValue, setTitlesValue } = require('actions/brokerTransferValues');
// @ contants
const { BROKER_TRANSFER_VALUES_TYPE_TOTAL } = require('constants/index');

class BrokerTransferValuesTable extends React.Component {
    constructor (props) {
        super(props);

        this.buildTableHeader = this.buildTableHeader.bind(this);
        this.buildTableBody = this.buildTableBody.bind(this);
    }

    buildTableBody () {
        const { immContractValues, immTransferValues, contractId, toggleCheckValue, setTitlesValue } = this.props;
        const immValues = immContractValues.getIn([contractId, 'byId']);
        const onlyRowSelected = immValues.size === 1;
        let rows = [];
        const isTotalTypeSelected = immTransferValues.getIn(['steps', 1, BROKER_TRANSFER_VALUES_TYPE_TOTAL, 'selected']);

        immValues.forEach(immValue => {
            const selectable = !isTotalTypeSelected;
            rows.push(
                <BrokerTransferValuesTableRow
                    key={`key_checkboxValues${immValue.get('id')}`}
                    immValue={immValue}
                    immTransferValues={immTransferValues}
                    setTitlesValue={setTitlesValue}
                    toggleCheckValue={toggleCheckValue}
                    onlyRowSelected={onlyRowSelected}
                    selectable={selectable}
                />)
        });

        return rows;
    }

    buildTableHeader () {
        return (
            <OKTableRow asHeader={true}>
                <OKTableCell asHeader={true} className="broker-transfer-values-table__cell-header" />
                <OKTableCell asHeader={true} className="broker-transfer-values-table__cell-header">
                    <FormattedText value="broker-transferValuesStep2TableHeaderName" />
                </OKTableCell>
                <OKTableCell asHeader={true} className="broker-transfer-values-table__cell-header">
                    <FormattedText value="broker-transferValuesStep2TableHeaderPrice" />
                </OKTableCell>
                <OKTableCell asHeader={true} className="broker-transfer-values-table__cell-header">
                    <FormattedText value="broker-transferValuesStep2TableHeaderValue" />
                </OKTableCell>
                <OKTableCell asHeader={true} className="broker-transfer-values-table__cell-header">
                    <FormattedText value="broker-transferValuesStep2TableHeaderTitles" />
                </OKTableCell>
                <OKTableCell asHeader={true} className="broker-transfer-values-table__cell-header">
                    <FormattedText value="broker-transferValuesStep2TableHeaderTitlesForTransfer" />
                </OKTableCell>
            </OKTableRow>
        );
    }

    render () {
        const tableHeader = this.buildTableHeader();
        const tableBody = this.buildTableBody();

        return (
            <section>
                <OKTable>
                    <thead>{tableHeader}</thead>
                    <tbody>{tableBody}</tbody>
                </OKTable>
            </section>
        );
    }
}

BrokerTransferValuesTable.propTypes = {
    contractId: PropTypes.string.isRequired,
    immContractValues: PropTypes.object.isRequired,
    immTransferValues: PropTypes.object.isRequired,
    toggleCheckValue: PropTypes.func.isRequired,
    setTitlesValue: PropTypes.func.isRequired
}

module.exports = connect(null, {
    toggleCheckValue,
    setTitlesValue,
})(BrokerTransferValuesTable);